import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-list-item',
    templateUrl: './list.item.component.html',
    styleUrls: ['./list.item.component.scss'],
    host: {
        '[class.gray]': 'isGray',
        '[class.contain-link]': 'link',
        '[class.ic-list-item]': 'true'
    },
    encapsulation: ViewEncapsulation.None
})
export class ListItemComponent {
    @Input() public link: string;
    @Input() public isGray: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/item/list.item.component.ts